/**
 * Controls the loading overlay visibility and progress
 * @param isLoading Boolean indicating if content is still loading
 * @param progress Number between 0-100 representing loading progress
 */
export function updateLoading(isLoading: boolean, progress: number): void {
  const loadingOverlay = document.getElementById('loading-overlay');
  if (!loadingOverlay) return;

  // Ensure progress is within valid range
  const validProgress = Math.max(0, Math.min(100, Math.round(progress)));
  
  // Update data attributes
  loadingOverlay.setAttribute('data-loading', isLoading.toString());
  loadingOverlay.setAttribute('data-progress', validProgress.toString());
  
  // Update UI elements directly for immediate feedback
  const progressBar = document.getElementById('progress-bar');
  const progressPercentage = document.getElementById('progress-percentage');
  
  if (progressBar) {
    progressBar.style.width = `${validProgress}%`;
  }
  
  if (progressPercentage) {
    progressPercentage.textContent = `${validProgress}%`;
  }

  const counter = document.getElementById('loader-counter');
  if (counter) {
    counter.textContent = `${validProgress}`;
  }

}

/**
 * Removes the loading overlay from the DOM after a delay
 */
export function hideLoadingOverlay(): void {
  const loadingOverlay = document.getElementById('loading-overlay');
  if (!loadingOverlay) return;

  // Wait for the CSS opacity transition (600ms) to finish before removal
  setTimeout(() => {
    loadingOverlay.remove();
  }, 700);
}
